import { CircleCheckBigIcon, InfoIcon, Loader2Icon, CircleXIcon, TriangleAlertIcon } from "lucide-react";
import { Toaster as Sonner } from "sonner";
import { cn } from "@/utils/css";

export const Toaster = ({ hidden = false, ...props }) => {
    return (
        <Sonner
            className={cn("toaster group", { hidden })}
            icons={{
                success: <CircleCheckBigIcon className="size-5" />,
                info: <InfoIcon className="size-5" />,
                warning: <TriangleAlertIcon className="size-5" />,
                error: <CircleXIcon className="size-5" />,
                loading: <Loader2Icon className="size-5 animate-spin" />,
            }}
            style={{
                "--normal-bg": "var(--cm-p-surface)",
                "--normal-text": "var(--cm-p-text-primary)",
                "--width": "400px",
            }}
            expand
            toastOptions={{
                style: {
                    whiteSpace: "pre-line",
                },
                classNames: {
                    error: "cm-toast-error",
                    success: "cm-toast-success",
                    warning: "cm-toast-warning",
                },
            }}
            {...props}
        />
    );
};
